import { gql } from "@apollo/client";

export const GET_PACIENTE_CONTRATOS = gql`
query pacienteContratos($idPaciente: Int!) {
  pacienteContratos(idPaciente: $idPaciente) {
    success
    error
    valorEsperado {
      contrato
      programa
      planCuidado
      estadoContrato
      estadoAsistencial
      fechaDesde
      fechaHasta
      fechaDesdeSuspension
      fechaHastaSuspension
      codigoCliente
      cliente
      precioDiario
    }
  }
}`;
